import { useState, useEffect } from 'react';
import { transform } from '../Pages/SearchResult/Utils.jsx';
import { CLOUD_BASE_URL } from '../Constant/constant.js';

const libCodeMap = {
  嘉義市政府文化局: 'cy',
  國家圖書館: '',
  國立臺灣圖書館: 'ntl2',
  基隆市文化局: 'kl',
  彰化雲端電子書庫: 'chc',
  新北市立圖書館: 'nt',
  新竹市圖書館: 'hc',
  新竹縣政府文化局: 'hcc',
  桃園市立圖書館: 'ty',
  澎湖縣圖書館: 'ph',
  臺中市立圖書館: 'tc',
  臺北市立圖書館: 'tpe',
  臺南市立圖書館: 'tn',
  臺東縣政府文化處: 'tt',
  花蓮縣文化局: 'hl',
  苗栗市立圖書館: '',
  苗栗縣立圖書館: 'ml',
  連江縣公共圖書館: '',
  金門縣文化局: 'km',
  高雄市立圖書館: 'ks',
};

const useCloudSearch = (cities, searchBookName) => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const activeLibs = Object.entries(cities)
      .filter(([_, isActive]) => isActive)
      .map(([name]) => ({ name, code: libCodeMap[name] }))
      .filter(({ code }) => !!code);

    if (!searchBookName || activeLibs.length === 0) {
      setResults([]);
      setLoading(false);
      setError(null);
      return;
    }

    const fetchAll = async () => {
      setLoading(true);
      setError(null);
      const all = [];

      try {
        await Promise.all(
          activeLibs.map(async ({ name, code }) => {
            try {
              const res = await fetch(
                `${CLOUD_BASE_URL}/api/ebookservice/search?lib=${code}&q=${searchBookName}`
              );
              const json = await res.json();

              if (Array.isArray(json?.payload?.hits?.hit)) {
                const books = json.payload.hits.hit.map((b) => ({
                  title: b.fields.title,
                  link: `https://www.ebookservice.tw/${
                    code === 'tpe' ? 'tp' : code
                  }/book/${b.fields.id}`,
                  library: name,
                }));
                all.push(...books);
              }
            } catch (err) {
              console.warn(`Fail from ${name}:`, err.message);
            }
          })
        );
        setResults(all);
      } catch (err) {
        setError(err);
        setResults([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, [cities, searchBookName]);

  return { results: transform(results), loading, error };
};

export default useCloudSearch;
